module.exports = __webpack_public_path__ + "img/DirhamBlack.14f30568.svg";